<div class="user-preferences-container">
  <div class="preferences-grid">
    <div class="preference-item">
      <label for="pageamount" class="preference-label">
        <i class="pi pi-list text-primary mr-2"></i>
        Page Amount
      </label>
      <p class="preference-description text-600 mb-3">
        Select the number of items to display per page in tables and lists
      </p>
      <p-dropdown
        appendTo="body"
        [options]="pageAmountOptions"
        [(ngModel)]="pageAmount"
        id="pageamount"
        placeholder="Select page amount"
        class="w-full"
      ></p-dropdown>
      <div class="mt-3">
        <p-button
          label="Save Preference"
          icon="pi pi-check"
          styleClass="p-button-primary"
          (onClick)="changePageAmount()"
        ></p-button>
      </div>
    </div>
  </div>
</div>
